import ApiService from "../../../../../services/ApiService";
import translate from "../../../../../services/Translate";

export const fetchEvaluations = (setEvaluations: Function, setLoading: Function, language: string) => {
  setLoading(true);
  ApiService.get("evaluations")
    .then((response) => setEvaluations(response.data.evaluations))
    .catch((error) => {
      console.error("Failed to fetch evaluations", error);
      alert(translate(language, "PAGES.MODULE.ERROR.FETCH_MODULE_EVALUATIONS"));
    })
    .finally(() => setLoading(false));
};

export const linkEvaluationToModule = (
  moduleId: string,
  evaluationId: number,
  language: string,
  onSuccess: Function,
  setLoading: Function
) => {
  setLoading(true);
  ApiService.post(`modules/${moduleId}/evaluations/${evaluationId}`, {})
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Failed to link evaluation to module", error);
      alert(translate(language, "PAGES.MODULE.ERROR.ADD_EVALUATION_TO_MODULE"));
    })
    .finally(() => setLoading(false));
};
